import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkCurrentColor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1.4284,0,0,1.4284,-3.95765,-3.9172)",
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("path", { d: "M2.771,7.133L4.992,7.133L6.326,9.282L10.966,3.166L12.572,4.358L6.326,12.225L2.771,7.133Z" })
	})
});
export default SvgCheckmarkCurrentColor;
